import angular from 'angular'

import envRaw from '../utils/env-raw'

import { defaultTo } from '../utils/bits'
import { onClick, offClick } from '../utils/on-click'

angular
  .module('ggs.halt-click')
  .directive('ggsHaltClick', HaltClickDirective)

function HaltClickDirective(ApplyAsync) {
  return {
    restrict: 'A',
    link($scope, $elm, $attr) {
      let handler = null
      const eventName = defaultTo($scope.$eval($attr.ggsHaltClickEvent), envRaw.clickEvent)

      onClick($elm, eventName, clickHandler)
      $scope.$on('$destroy', destroyHandler)

      function destroyHandler() {
        offClick($elm, eventName, clickHandler)
      }

      function clickHandler(event) {
        event.stopPropagation()
        if (!handler) {
          handler = ApplyAsync($scope, $attr.ggsHaltClick)
        }
        handler()
      }
    }
  }
}
